import { render } from "./consultGallery.vue?vue&type=template&id=038bb2a2&scoped=true"
import script from "./consultGallery.vue?vue&type=script&lang=js"
export * from "./consultGallery.vue?vue&type=script&lang=js"

import "./consultGallery.vue?vue&type=style&index=0&id=038bb2a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038bb2a2"]])

export default __exports__